// Use $ instead of $ without replacing global $
(function ($) {
  $(document).ready(function () {

    $(window).on('load scroll', function () {
      var scroll = $(window).scrollTop();
      if (scroll >= 240) {
        $('.audio-box').addClass('show');
        $(".audio-box").removeClass("load-audio-play");
      } else {
        $('.audio-box').removeClass('show');
      }
    });

    $(document).on('click', '.audio-play', function (e) {
      e.preventDefault();
      e.stopPropagation();

      $(".audio-overlay").addClass("active");
      $(this).toggleClass('active');
      $(this).parent().toggleClass('we-audio-play');
      $(this).parent().addClass('we-play');
      if ($(this).hasClass('active')) {
        document.getElementById('player').play();
      } else {
        document.getElementById('player').pause();
      }
    });
  });

  $(window).on('load', function () {
    $(".audio-box").addClass("load-audio-play");
  });
})(jQuery);

